import React from 'react';
import { IconButton } from '@mui/material';
import { useTheme } from '../contexts/ThemeContext';
import { MoonIcon, SunIcon } from './Icons';

export const ThemeToggle: React.FC = () => {
  const { darkMode, toggleTheme } = useTheme();

  return (
    <IconButton 
      onClick={toggleTheme} 
      sx={{ 
        color: '#fff',
        '&:hover': {
          backgroundColor: 'rgba(179, 0, 0, 0)'
        }
      }}
      aria-label="Theme umschalten"
    >
      {darkMode ? <SunIcon style={{ color: '#e8ff14ff' }} /> : <MoonIcon style={{ color: '#525252ff' }} />}
    </IconButton>
  );
};
